import { useEffect, useState } from 'react';
import { Box, CardHeader } from '@mui/material';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { YouTube, Telegram, Facebook, Twitter, Instagram } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import SERVER_API_URL from '../../../config';

const StyledLink = styled(Link)`
  ${({ theme }) => `
    cursor: pointer;
    color: ${theme.palette.primary.main};
    transition: ${theme.transitions.create(['color', 'transform'], {
      duration: theme.transitions.duration.standard,
    })};
    &:hover {
      color: ${theme.palette.secondary.main};
      transform: scale(1.5);
    }
  `}
`;
// ----------------------------------------------------------------------

export default function SocialMedia({ title, subheader }) {
  const [socialMedias, setSocialMedias] = useState();

  useEffect(() => {
    const getAllMedias = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/landing/getSocialMedias`);
        if (response.status === 200) {
          setSocialMedias(response.data);
        }
      } catch (error) {
        // Handle error
      }
    };

    getAllMedias();
  }, []);

  return (
    <Box>
      <CardHeader title={title} subheader={subheader} />
      <Box
        sx={{
          p: 3,
          gap: 2,
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 1fr)',
          justifyContent: 'left',
          maxWidth: 300,
        }}
      >
        {socialMedias &&
          socialMedias.map((site) => (
            <StyledLink
              key={site.name}
              to={site.url}
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {site.name === 'Youtube' ? (
                <Box sx={{ mb: 0.5 }}>
                  {' '}
                  <YouTube sx={{ fontSize: 32, color: 'red', pt: 1 }} />
                </Box>
              ) : site.name === 'Facebook' ? (
                <Box sx={{ mb: 0.5 }}>
                  {' '}
                  <Facebook sx={{ fontSize: 32, color: '#1877F2', pt: 1 }} />{' '}
                </Box>
              ) : site.name === 'Telegram' ? (
                <Box sx={{ mb: 0.5 }}>
                  <Telegram sx={{ fontSize: 32, color: 'blue', pt: 1 }} />{' '}
                </Box>
              ) : site.name === 'Instagram' ? (
                <Instagram sx={{ fontSize: 32, color: '#b430b2', pt: 1 }} />
              ) : site.name === 'Twitter' ? (
                <Twitter sx={{ fontSize: 32, color: '#1C9CEA', pt: 1 }} />
              ) : (
                <></>
              )}
            </StyledLink>
          ))}
      </Box>
    </Box>
  );
}

SocialMedia.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
};
